import surveyOptions from '../options/survey';

export default {
  q_text: {
    value: '',
    error: null,
    name: 'q_text',
    placeholder: 'How was ...',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  q_type: {
    value: '',
    error: null,
    name: 'q_type',
    placeholder: 'Question Type',
    breed: 'select',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
    options: surveyOptions,
    displayValue: '',
    isActive: false
  }
}



/** WEBPACK FOOTER **
 ** ./src/forms/survey/question.js
 **/